import { getAllNotificationsByUser } from "../auth/actions";
import storePersist from "../storePersist";
import * as actionTypes from "./types";
import * as authActionTypes from "../auth/types";
import * as appService from "@/appServices";
import store from "../store";
import { sortingDataHelper } from "@/utils/helpers";
const state = store?.getState();
const auth = state?.auth;

export const carMake = () => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const carMake = await appService.getCarMakesList();

  if (carMake.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        carMake: carMake?.data,
      },
    });
  } else {
    dispatch({
      type: actionTypes.REQUEST_FAILED,
    });
  }
};

export const carModel = (id) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const carModel = await appService.getAllCarModels(id);

  if (carModel.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        carModel: carModel?.data,
      },
    });
  } else {
    dispatch({
      type: actionTypes.REQUEST_FAILED,
    });
  }
};

export const getAppraisalById = (id) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const appraisal = await appService.getAppraisalById(id);

  if (appraisal.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        selectedAppraisal: appraisal?.data,
      },
    });
  }
};

export const fetchAppraisalRequests =
  ({
    pageNo,
    pageSize,
    overDue,
    status,
    claimOrVinNum,
    payType,
    model,
    startDate,
    endDate,
    sortOrder,
    sortField,
    customer,
    customListName,
    customListPagination,
  }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const appraisalsList = await appService.getAppraisalListing({
      pageNo,
      pageSize,
      overDue,
      status,
      claimOrVinNum,
      payType,
      model,
      startDate,
      endDate,
      sortOrder,
      sortField,
      customer,
    });
    if (appraisalsList.success) {
      let payload = {
        [customListName]: appraisalsList?.data?.appraisals,
        [customListPagination]: {
          current: pageNo,
          pageSize: pageSize,
          total: appraisalsList?.pagination?.totalItems,
        },
        pageStatusCount: appraisalsList?.data?.statusCounts.map((item) => ({
          ...item,
          customListName: item.status.replace(" ", "_"),
        })),
        pagination: {
          current: pageNo,
          pageSize: pageSize,
          total: appraisalsList?.pagination?.totalItems,
        },
      };
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload,
      });
    }
  };

export const setAppraisalListing = (response) => async (dispatch) => {
  dispatch({
    type: actionTypes.CURRENT_PAGE_SUCCESS,
    payload: { appraisalListing: response?.result },
  });
};

export const updateChatState = (updatedChat) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_CHAT, payload: updatedChat });
};

export const getAllShops =
  ({ pageNo, pageSize, status, isActive }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const shopList = await appService.fetchAllShops({
      pageNo,
      pageSize,
      status,
      isActive,
    });
    if (shopList?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          shopTableData: shopList?.data?.shops,
          shopPagination: {
            current: pageNo,
            pageSize: pageSize,
            total: shopList?.data?.pagination?.totalItems,
          },
        },
      });
    }
  };

export const getShopByIdAction =
  ({ id }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const _shop = await appService.getShopById(id);

    if (_shop?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
      });

      const _localStorage = { ...JSON.parse(localStorage.getItem("auth")) };
      let _shopProfile = { ..._localStorage?.shopProfile };

      _shopProfile = {
        ..._shopProfile,
        ..._shop?.data,
      };

      _localStorage.shopProfile = _shopProfile;
      localStorage.setItem("auth", JSON.stringify(_localStorage));

      store.dispatch({
        type: authActionTypes.SHOP_PROFILE,
        payload: _shopProfile
      });
    }
    dispatch({ type: actionTypes?.LOADING_FALSE });
    return _shop?.data
  };

export const getAllStaff =
  ({ pageNo, pageSize, status, role, excludeRole, shopOwnerTable, isActive }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const staffList = await appService.fetchAllStaff(
      {
        pageNo,
        pageSize,
        status,
        isActive,
      },
      role
    );
    if (staffList?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: !shopOwnerTable
          ? {
              staffTableData: staffList?.data?.users,
              staffPagination: {
                current: pageNo,
                pageSize: pageSize,
                total: staffList?.data?.pagination?.totalItems,
              },
            }
          : {
              shopOwnerTableData: staffList?.data?.users,
              shopOwnerPagination: {
                current: pageNo,
                pageSize: pageSize,
                total: staffList?.data?.pagination?.totalItems,
              },
            },
      });
    }
  };

export const editShopInfo = (_id) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const shopInfo = await appService.getShopById(_id);

  dispatch({
    type: actionTypes.REQUEST_SUCCESS,
  });

  if (shopInfo.success) {
    return {
      shopInfo: shopInfo?.data,
      success: shopInfo?.success,
    };
  }
};

export const editShopToActiveOrInactiveAction =
  (_id, data, listing) => async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const updatedShop = await appService.editShopToActiveOrInactive(_id, data);

    if (updatedShop.success) {
      return {
        shopInfo: updatedShop?.data,
        success: updatedShop?.success,
      };
    }
  };

export const getAllRoles =
  ({ pageNo, pageSize }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const roleList = await appService.fetchAllRoles({
      pageNo,
      pageSize,
    });
    if (roleList?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          roleTableData: roleList?.data?.roles,
          rolePagination: {
            current: pageNo,
            pageSize: pageSize,
            total: roleList?.data?.pagination?.totalItems,
          },
        },
      });
    }
  };

export const deletShop = (id, listing) => async (dispatch) => {
  try {
    const shopDeleted = await appService.deleteShopById(id);

    if (shopDeleted?.success) {
      const _listing = listing?.shopTableData;
      const updatedShopTableData = _listing?.map((item) =>
        item?._id === id ? { ...item, isActive: false } : item
      );

      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          shopTableData: updatedShopTableData,
        },
      });
    }
  } catch (error) {
    console.log("Error Deleting: ", error);
  }
};

export const editStaffInfo = (_id) => async (dispatch) => {
  const staffInfo = await appService.getStaffById(_id);

  dispatch({
    type: actionTypes.REQUEST_SUCCESS,
  });

  if (staffInfo.success) {
    return {
      staffInfo: staffInfo?.data,
      success: staffInfo?.success,
    };
  }
};

export const getAllAppraisalForWriterWorkload =
  ({ pageNo, pageSize, status, startDate, endDate, writerId, pagination }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const appraisalsList = await appService.getAppraisalListing({
      pageNo,
      pageSize,
      status,
      startDate,
      endDate,
      writerId,
      pagination,
    });
    if (appraisalsList.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          WorkLoadTableData: appraisalsList?.data?.appraisals,
          workLoadPagination: {
            current: pageNo,
            pageSize: pagination
              ? pageSize
              : appraisalsList?.pagination?.totalItems,
            total: appraisalsList?.pagination?.totalItems,
          },
        },
      });
    }
  };

export const getAppraisalWorkloadListing = (params) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const appraisalsWorkloadListing = await appService.getAppraisalWorkload(
    params
  );
  if (appraisalsWorkloadListing.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        appraisalWorkload: appraisalsWorkloadListing?.data,
      },
    });
  }
  dispatch({ type: actionTypes?.LOADING_FALSE });
};

export const getAllWritersDataForQualityTable =
  ({
    pageNo,
    pageSize,
    status,
    startDate,
    endDate,
    assignedTo,
    shopId,
    pagination,
  }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const writerQualityData = await appService.getWriterQualityDataListing({
      pageNo,
      pageSize,
      status,
      startDate,
      endDate,
      writerId: assignedTo,
      shopId,
      pagination,
    });
    if (writerQualityData.success) {
      const sortedData = sortingDataHelper(
        writerQualityData?.result?.writerQuality,
        "descend",
        "avgTimeNewToUpInsurance"
      );
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          WorkQualityTableData: sortedData,
          workQualityPagination: {
            current: pageNo,
            pageSize: pagination
              ? pageSize
              : writerQualityData?.result?.pagination?.totalItems,
            total: writerQualityData?.result?.pagination?.totalItems,
          },
        },
      });
    }
  };

export const updateAppraisalStatusState =
  (changedStatus) => async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_APPRAISAL_STATUS,
      payload: changedStatus,
    });
  };

export const getWriterWorkloadListing = (params) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const writerWorkloadListing = await appService.getWriterWorkload(params);
  if (writerWorkloadListing.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        writerWorkload: writerWorkloadListing?.data.writerWorkload,
      },
    });
  }
};

export const createNewInsuranceAction = (params) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const insurancelisting = await appService.createNewInsuranceCompany(params);
  const pageDataParams = { pageNo: 1, pageSize: 10, status: "" };
  dispatch(getInsuranceCompanyListing(pageDataParams));
};

export const getInsuranceCompanyListing =
  ({ pageNo, pageSize }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const insuranceCompanyListing = await appService.getAllInsuranceListing({
      pageNo,
      pageSize,
    });

    if (insuranceCompanyListing?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          insuranceCompaniesTableData:
            insuranceCompanyListing?.data?.insurances,
          insuranceCompaniesPagination: {
            current: pageNo,
            pageSize: pageSize,
            total: insuranceCompanyListing?.data?.pagination?.totalItems,
          },
        },
      });
    }
  };

export const getInsuranceCompaniesAction =
  ({ pagination }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const insuranceCompanyListing = await appService.getAllInsuranceListing({
      pagination,
    });

    if (insuranceCompanyListing?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          insuranceCompaniesDropDownData:
            insuranceCompanyListing?.data?.insurances,
        },
      });
      return {
        insuranceCompanies: insuranceCompanyListing?.data?.insurances,
      };
    }
  };

export const getInsuranceByIdAction = (_id) => async (dispatch) => {
  dispatch({
    type: actionTypes.REQUEST_LOADING,
  });
  const insuranceCompany = await appService.getInsuranceCompanyById(_id);
  if (insuranceCompany.success) {
    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        selectedInsuranceCompany: insuranceCompany?.data,
      },
    });
  }
  return {
    success: true,
    insurance: insuranceCompany?.data,
  };
};

export const deletInsuranceAction = (id, listing) => async (dispatch) => {
  try {
    const insuranceDeleted = await appService.deleteInsuranceById(id);
    if (insuranceDeleted?.success) {
      const pageDataParams = { pageNo: 1, pageSize: 10, status: "" };
      dispatch(getInsuranceCompanyListing(pageDataParams));
    }
  } catch (error) {
    console.log("Error Deleting Insurance: ", error);
  }
};

export const updateInsuranceAction = (_id, data) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const insuranceUpdated = await appService.editInsuranceCompany(_id, data);
    if (insuranceUpdated?.success) {
      dispatch({
        type: actionTypes.REQUEST_SUCCESS,
      });
      const pageDataParams = { pageNo: 1, pageSize: 10, status: "" };
      dispatch(getInsuranceCompanyListing(pageDataParams));
    }
  } catch (error) {
    console.log("Error Updating Insurance: ", error);
  }
};

export const getSlaConfigAction = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const slaConfigFetched = await appService.fetchSlaConfigService();
    if (slaConfigFetched?.success) {
      dispatch({
        type: actionTypes.LOADING_FALSE,
      });
      return slaConfigFetched?.data;
    }
  } catch (error) {
    console.log("Error Updating SLA: ", error);
  }
};

export const updateSlaConfigAction = (slaConfig) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const slaConfigUpdated = await appService.updateSlaConfigService(slaConfig);
    if (slaConfigUpdated?.success) {
      dispatch({
        type: actionTypes.REQUEST_SUCCESS,
      });
    }
  } catch (error) {
    console.log("Error Updating SLA: ", error);
  }
};

export const getOverdueDataAction = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const overDueData = await appService.getOverdueDataService();
    if (overDueData?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          overdueData: overDueData?.data,
        },
      });
    }
  } catch (error) {
    console.log("Error Getting Overdue data: ", error);
  }
};

export const updateRatingAction =
  (data, action, appraisalId) => async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
      });
      const _data = {
        [action]: data,
        updatedBy: data?.ratedBy,
        appraisalId,
      };

      const ratingData = await appService.updateRating(_data, appraisalId);
      if (ratingData?.success) {
        dispatch({
          type: actionTypes.CURRENT_PAGE_SUCCESS,
          payload: {
            [action]: ratingData?.data,
          },
        });
      }
    } catch (error) {
      console.log("Error Updating Rating Data: ", error);
    }
  };

export const getRateListingForShopsAction =
  (param, actionName) => async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
      });

      const ratingDataList = await appService.getRateListingForShopsService(
        param
      );
      if (ratingDataList?.success) {
        dispatch({
          type: actionTypes.CURRENT_PAGE_SUCCESS,
          payload: {
            [actionName]: ratingDataList?.data,
          },
        });
      }
    } catch (error) {
      console.log("Error Updating Rating Data: ", error);
    }
  };

export const getRateListingWritersAction = (shopId) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });

    const ratingWriterList = await appService.getRateListingWritersService({
      shopId,
    });
    if (ratingWriterList?.success) {
      dispatch({
        type: actionTypes.CURRENT_PAGE_SUCCESS,
        payload: {
          ratingWriters: ratingWriterList?.data?.writers,
        },
      });
    }
  } catch (error) {
    console.log("Error Getting Rating Writer: ", error);
  }
};

export const verifyTokenIfExpiredOrNot = (token) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });

    const VerifyToken = await appService.VerifyTokenService(token);

    dispatch({
      type: actionTypes.LOADING_FALSE,
    });
    return VerifyToken?.success;
  } catch (error) {
    console.log("Error Getting Rating Writer: ", error);
  }
};

export const resendOnboardingEmail = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });

    const emailResent = await appService.resendEmail(id);

    dispatch({
      type: actionTypes.LOADING_FALSE,
    });
  } catch (error) {
    console.log("Error Getting Rating Writer: ", error);
  }
};

export const updateUserAction =
  ({ id, name, phone, isActive }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
      });

      const userUpdated = await appService.updateUsers({
        id,
        name,
        phone,
        isActive,
      });

      dispatch({
        type: actionTypes.REQUEST_SUCCESS,
      });
    } catch (error) {
      console.log("Error updating user: ", error);
    }
  };
